import { render } from "./ShopLeftSidebar.vue?vue&type=template&id=88e2658c&ts=true"
import script from "./ShopLeftSidebar.vue?vue&type=script&lang=ts"
export * from "./ShopLeftSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__